"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface ClosingCtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, ClosingCtaCopy> = {
  en: {
    eyebrow: "Material Engineering & Selection",
    heading: "Need Specific Stainless Steel Mesh Alloys or Surface Finishes?",
    lead: "Share your target fluid chemistry, operating temperatures, or existing specifications with our materials specialists to identify the right alloy grade.",
    secondaryLabel: "Contact Technical Team"
  },
  zh: {
    eyebrow: "材料工程与选型",
    heading: "需要特定不锈钢丝网合金或表面处理？",
    lead: "可将您的工艺介质化学条件、工作温度或现有技术规格提供给我们，由材料专业人员协助匹配合适的不锈钢合金牌号。",
    secondaryLabel: "联系技术团队"
  },
  es: {
    eyebrow: "Ingeniería de materiales y selección",
    heading: "¿Necesita aleaciones de malla o acabados superficiales específicos?",
    lead: "Comparta la química del fluido, temperaturas de trabajo o especificaciones existentes con nuestros especialistas para identificar la aleación adecuada.",
    secondaryLabel: "Contactar al equipo técnico"
  },
  de: {
    eyebrow: "Werkstofftechnik & Auswahl",
    heading: "Benötigen Sie spezifische Edelstahllegierungen oder Oberflächenbehandlungen?",
    lead: "Teilen Sie uns Ihre Medienbedingungen, Betriebstemperaturen oder bestehende Spezifikationen mit, um die passende Legierungsgüte zu bestimmen.",
    secondaryLabel: "Technisches Team kontaktieren"
  },
  fr: {
    eyebrow: "Ingénierie des matériaux et sélection",
    heading: "Besoin d'alliages de toile inox ou de finitions spécifiques ?",
    lead: "Transmettez la chimie du fluide, les températures de service ou vos spécifications existantes à nos spécialistes pour définir la nuance d'alliage adaptée.",
    secondaryLabel: "Contacter l'équipe technique"
  },
  pt: {
    eyebrow: "Engenharia de materiais e seleção",
    heading: "Precisa de ligas de malha de aço inoxidável ou acabamentos específicos?",
    lead: "Compartilhe as condições químicas do fluido, temperaturas de trabalho ou especificações existentes para definirmos o grau de liga ideal.",
    secondaryLabel: "Falar com a equipe técnica"
  }
};
export default function ClosingCta() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="materials-surface-finishes-cta" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ContactPage"
  }} />;
}